import { takeLatest, select, call, put, all } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as proxy from '../api/proxyApi';
import * as common from './commonSaga';
import { logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";
import { PROXY_APPROVED, PROXY_DECLINED, PROXY_PENDING } from "../constants/textConstants";


export default function* proxySaga() {
    //Keeping Pharamcy proxy activity codes which we have already.
    yield takeLatest(types.REQUEST_PROXY_INFO, handle, proxy.getProxiesInfo, null);
    yield takeLatest(types.REQUEST_PROXY_CHANGE_STATUS, handle, proxy.changeRequestStatus, null);
    yield takeLatest(types.REQUEST_PROXY_ACCESS_LIST, handle, proxy.getAccessList, null);
    yield takeLatest(types.REQUEST_PROXY_FAMILY_MEMBERS_LIST, handle, proxy.getFamilyMembersList, null);
    yield takeLatest(types.REQUEST_PROXY_RESEND, handle, proxy.resendProxyAccess, 'Resend');
    yield takeLatest(types.REQUEST_PROXY_CANCEL, handle, proxy.changeRequestStatus, 'Cancel');    
    yield takeLatest(types.VERIFY_REQUESTOR_DOB, handle, proxy.verifyRequestorDateOfBirth, null);
    yield takeLatest(types.INITIATE_PROXY_RX_REQUEST, handle, proxy.initiateProxy, 'MBHWeb.Saga.Rx.Proxy.RequestProxyAccess');
    yield takeLatest(types.INITIATE_PROXY_EPIC_REQUEST, handle, proxy.initiateProxy, 'MBHWeb.Saga.Proxy.Epic.Request');
    //yield takeLatest(types.PROXY_RELATIONSHIP_TYPES, handle, null, 'MBHWeb.Saga.Proxy.GetProxyRelationshipTypes');
    yield takeLatest(types.INITIATE_PROXY_EPIC_GRANT, handle, proxy.initiateProxy, 'MBHWeb.Saga.Proxy.Epic.GrantInvite');    
    yield takeLatest(types.INITIATE_PROXY_RX_GRANT, handle, proxy.initiateProxy, 'MBHWeb.Saga.Proxy.Rx.GrantInvite'); 
    yield takeLatest(types.PROXY_STATUS, handle, proxy.proxyStatusInLogoutMode, 'MBHWeb.Saga.Proxy.ProxyStatus');    
    yield takeLatest(types.PROXY_TERMS_AND_CONDITIONS, handle, proxy.getProxyTermsAndConditions, null);
    yield takeLatest(types.ACCEPT_PROXY_TERMS_AND_CONDITIONS, handle, proxy.acceptProxyTermsAndConditions, null);
    yield takeLatest(types.PROXY_DETAILS, handle, proxy.proxyDetails, 'MBHWeb.Saga.Proxy.ProxyDetails');
    yield takeLatest(types.REQUEST_PROXY_SUGGESTION_LIST, fetchProxySuggestionList);
    yield takeLatest(types.POST_MAMMOGRAPHY_FLOW_DATA, postMammographyFlowData);
}

function* postMammographyFlowData() {
    const mammographyFlowFormInputs = yield select((state) => state.careGap.mammographyFlowFormInputs);
    const mammographyNoReason = yield select((state) => state.careGap.selectedNoMammographyReason);
    const mammpgraphyOption = yield select((state) => state.careGap.selectedMammographyOption);
    const domain = yield select((state) => state.domain);
    const token = domain.t;
    const start = new Date();
    logAPI("MBHWeb.Saga.ProxySaga.MammographyFlow.Start", start, null, null);
    try {
        yield put({ type: types.GET_MAMMOGRAPHY_FLOW_DATA })

        let result = yield call(proxy.submitCareGapInfo, token, mammographyFlowFormInputs, mammographyNoReason, mammpgraphyOption);
        if (result.success === true) {
            //dispatch one action for success
            yield put({ type: types.POST_MAMMOGRAPHY_FLOW_DATA_STATUS, result})
            logAPI("MBHWeb.Saga.ProxySaga.MammographyFlow.Success", start, null, result);
        } else {
            //dispatch one action for failure
            yield put({ type: types.POST_MAMMOGRAPHY_FLOW_DATA_STATUS, result })
            logAPI("MBHWeb.Saga.ProxySaga.MammographyFlow.Failure", start, null, result);
        }
    } catch (err) {
        yield put({ type: types.POST_MAMMOGRAPHY_FLOW_DATA_STATUS, err })
        logAPI("MBHWeb.Saga.ProxySaga.MammographyFlow.Failure", start, null, result);
    }

}

function* fetchProxySuggestionList() {
    let result = { data: null, success: false, errorMsg: null }
    const start = new Date();
    logAPI("MBHWeb.Saga.ProxySaga.ProxySuggestions.Get.Start", start, null, null);
    try {
        const domain = yield select((state) => state.domain);
        const token = domain.t;
        const data = yield call(proxy.getProxySuggestion, token);

        if (data) {
            result.data = data;
            result.success = true; 
            logAPI("MBHWeb.Saga.ProxySaga.ProxySuggestions.Get.Success", start, null, result);
        }       
        yield put({ type: types.GET_PROXY_SUGGESTION_LIST, payload: result })
    } catch (e) {
        result.error=e;
        result.success = false
        logAPI("MBHWeb.Saga.ProxySaga.ProxySuggestions.Get.Failure", start, null, result);
        yield put({ type: types.GET_PROXY_SUGGESTION_LIST, payload: result })
    }

}

function* handle(apiCall, andyliticsLogName, action) {
    const start = new Date();
    const REQUEST = "request";
    const REQUESTV2 = "request.v2";
    const GRANT = "grant";
    const session = yield select((state) => state.session);
    const useOnboardingLayout = session?.useOnboardingLayout ? ".OnboardingFlow" : "";
    andyliticsLogName = andyliticsLogName && `${andyliticsLogName}${useOnboardingLayout}`;
    try {
        const type = action.type;
        const domainData = yield select((state) => state.domain);
        if (domainData) {
            if (action.success) {
                //do something here               
                if (type === types.REQUEST_PROXY_CHANGE_STATUS || type === types.REQUEST_PROXY_RESEND || type === types.REQUEST_PROXY_CANCEL) {
                    let proxySource = "Rx";
                    if (domainData.hm) {
                        proxySource = "Rx,Epic";
                    }

                    if (type === types.REQUEST_PROXY_CHANGE_STATUS) {
                        window.setTimeout(() => {
                            window.store.dispatch({ type: types.CLEAR_PROXY_MESSAGE });
                        }, 10000);
                    }

                    if (type === types.REQUEST_PROXY_CANCEL || type === types.INITIATE_PROXY_RX_REQUEST || (type === types.REQUEST_PROXY_CHANGE_STATUS && action.data === "Approved")) {
                        yield put({ type: types.REQUEST_PROXY_ACCESS_LIST, data: { userId: domainData.un, proxySource } });
                        if (domainData.hm) {
                            yield put({ type: types.MEMBERSHIP_RECOMPILE_START });
                        }
                    }                        

                    if (type === types.REQUEST_PROXY_CANCEL || type === types.INITIATE_PROXY_RX_REQUEST || (type === types.REQUEST_PROXY_CHANGE_STATUS && action.data === "Approved")) {
                        yield put({ type: types.REQUEST_PROXY_FAMILY_MEMBERS_LIST, data: { userId: domainData.un, proxySource } });
                        if (domainData.hm) {
                            yield put({ type: types.MEMBERSHIP_RECOMPILE_START });
                        }
                    } 
                    //Skip Proxy Info Call for certain conditions - anonymous proxy request.
                    if (domainData.t) {
                        yield put({ type: types.REQUEST_PROXY_INFO, data: { userId: domainData.un, proxySource }, changeProxyStatus: true });
                    }
                }
            }
            else if (!action.error) {
                const proxySource = action && action.data && action.data.proxySource ? action.data.proxySource : "";
                const requestType = action && action.data && action.data.requestType ? action.data.requestType === GRANT ? "Grant" : requestType === REQUEST ? "Request" : (requestType === REQUESTV2 ? "Request.V2" : "") : "";
                if (type === types.REQUEST_PROXY_CHANGE_STATUS) {
                    if (action.data.status === PROXY_DECLINED) {
                        apiCall = domainData.t ? proxy.changeRequestStatus : proxy.declineProxyInLogoutMode;
                    }                    
                    andyliticsLogName = (action.data.status === PROXY_APPROVED) ? `MBHWeb.Saga.${proxySource}.Proxy.ApproveProxy${requestType}` :
                        (action.data.status === PROXY_PENDING) ? `MBHWeb.Saga.${proxySource}.Proxy.LinkProxy${requestType}` : `MBHWeb.Saga.${proxySource}.Proxy.DeclineProxy${requestType}`;
                }
                if (type === types.REQUEST_PROXY_INFO) {
                    andyliticsLogName = domainData.hm ? "MBHWeb.Saga.RxAndEpic.Proxy.GetProxyInfo" : "MBHWeb.Saga.Rx.Proxy.GetProxyInfo";
                }
                if (andyliticsLogName === "Resend") { andyliticsLogName = `MBHWeb.Saga.${proxySource}.Proxy.ResendProxyAccessRequest`; }
                if (andyliticsLogName === "Cancel") { andyliticsLogName = `MBHWeb.Saga.${proxySource}.Proxy.CancelProxy${requestType}`; }
                
                yield call(common.handle, apiCall, domainData.t, andyliticsLogName, action);
            }
            else {
                if (type === types.REQUEST_PROXY_CHANGE_STATUS) {
                    window.setTimeout(() => {
                        window.store.dispatch({ type: types.CLEAR_PROXY_MESSAGE });
                    }, 10000);
                }
                if (type === types.INITIATE_PROXY_RX_REQUEST) {
                    let error = action.error;
                    if (error && error.status && error.status === 409) {
                        const errorMessage = yield call(getErrorMsg, error);
                        yield put({ type: types.INITIATE_PROXY_RX_REQUEST_FAILURE, errorCode: error.status ? error.status : error, errorMessage: errorMessage ? errorMessage : null });
                    } else {
                        yield put({ type: types.INITIATE_PROXY_RX_REQUEST_FAILURE, errorCode: error.status ? error.status : error });
                    }
                }
                if (type === types.INITIATE_PROXY_EPIC_GRANT) {
                    let error = action.error;
                    let errorMessage = null, errorCode = null;
                    if (typeof error !== 'string') {
                        if (error.status || error.errorCode || error.statusCode) {
                            errorMessage = error.errorMessage; //yield call(getErrorMsg, error);
                            errorCode = error.status || error.errorCode || error.statusCode;
                        }                        
                    }
                    else {
                        errorMessage = errorCode = error;
                    }
                    yield put({ type: types.INITIATE_PROXY_EPIC_GRANT_FAILURE, errorMessage: errorMessage ? errorMessage : null, errorCode: errorCode });
                }
                if (type === types.INITIATE_PROXY_RX_GRANT) {
                    let error = action.error;
                    let errorMessage = null, errorCode = null;
                    if (typeof error !== 'string') {
                        if (error.status || error.errorCode || error.statusCode ) {
                            errorMessage = error.errorMessage; //yield call(getErrorMsg, error);
                            errorCode = error.status || error.errorCode || error.statusCode;
                        }
                    }
                    else {
                        errorMessage = errorCode = error;
                    }
                    yield put({ type: types.INITIATE_PROXY_RX_GRANT_FAILURE, errorMessage: errorMessage ? errorMessage : null, errorCode: errorCode });
                }
                if (type === types.VERIFY_REQUESTOR_DOB) {
                    let error = action.error;
                    let errorMessage = null;
                    if (error && error.status && error.status === 409) {
                        errorMessage = yield call(getErrorMsg, error);
                    }
                    yield put({ type: types.VERIFY_REQUESTOR_DOB_FAILURE, error: error });
                }
               
            }
        }
    }
    catch (e) {
        //debugger;
        console.error(e);
        logAPI("MBHWeb.Saga.ProxySaga.Get.Failure", start, null, response);
        if (response && response.status && response.status === 401) {
            yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
        }
        else {
            yield put({ type: types.AJAX_CALL_ERROR, proxyError: response });
        }
    }
}

function getErrorMsg(errMsg) {
    return errMsg.json().then(data => {
        return data;
    });
}


